
export default () => ({
  scrollIntoViewWithOffset(selector, offset) {
    window.scrollTo({
      behavior: 'smooth',
      top:
        selector.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        offset,
    })
  },
})
